<template>
  <div class="flex items-center gap-4">
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <span class="symbol">
          {{ symbol1 }}
        </span>
        <span class="direction">
          {{ direction(symbol1Direction) }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <span class="symbol">
          {{ symbol2 }}
        </span>
        <span class="direction">
          {{ direction(symbol2Direction) }}
        </span>
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <span>
        {{ orderState(tradingPhase) }}
      </span>
      <span v-if="entry">
        {{ calcTypeConversion(calcType) }}:
        {{ entry }}
      </span>
      <span v-else> - </span>
      <span class="text-gray-400">
        {{
          startDatetime
            ? moment(startDatetime).format("DD/MM/YYYY HH:mm:ss")
            : "-"
        }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    symbol1: {
      type: String,
    },
    symbol1Direction: {
      type: String,
    },
    symbol2: {
      type: String,
    },
    symbol2Direction: {
      type: String,
    },
    tradingPhase: {
      type: String,
    },
    calcType: {
      type: String,
    },
    entry: {
      type: Number,
    },
    startDatetime: {
      type: String,
    },
  },
  methods: {
    calcTypeConversion(calcType) {
      switch (calcType) {
        case "FACTOR":
          return "Fator";
        case "DIFFERENCE":
          return "Diferença";
        case "LINEAR_FUNCTION":
          return "Resíduo";
        default:
          return calcType;
      }
    },
    direction(direction) {
      switch (direction) {
        case "BUY":
          return "C";
        case "SELL":
          return "V";
        default:
          return direction;
      }
    },
    orderState(state) {
      switch (state) {
        case "NEW":
          return "Nova";
        case "ACTIVE":
          return "Ativa";
        case "ON_WAIT_ENTRY":
          return "Aguardando entrada";
        case "ON_ENTRY":
          return "Entrando";
        case "ON_WAIT_EXIT":
          return "Aguardando saída";
        case "ON_EXIT":
          return "Saindo";
        case "ON_TP":
          return "Executando TP";
        case "ON_SL":
          return "Executando SL";
        case "ON_TIME_EXIT":
          return "Saída por tempo";
        case "FILLED":
          return "Executada";
        default:
          return state;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.symbol {
  @apply bg-ontick-blue-900 text-ontick-blue-300 flex w-full items-center justify-center rounded-sm px-1.5 py-0.5 uppercase;
}
.direction {
  @apply bg-ontick-yellow-800 text-ontick-graphite-500 w-5 rounded-sm px-[6px] py-0.5 text-[10px] font-bold uppercase;
}
</style>
